/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamCorrectionGridQueryResponse,
  GetApiV1ExamCorrectionGridQueryParams,
  GetApiV1ExamCorrectionGrid400,
  GetApiV1ExamCorrectionGrid401,
  GetApiV1ExamCorrectionGrid500,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionGrid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamCorrectionGrid } from "../../clients/examCorrectionDashboardController/getApiV1ExamCorrectionGrid.ts";

export const getApiV1ExamCorrectionGridQueryKey = (
  params?: GetApiV1ExamCorrectionGridQueryParams,
) =>
  [
    { url: "/api/v1/exam/correction-grid" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamCorrectionGridQueryKey = ReturnType<
  typeof getApiV1ExamCorrectionGridQueryKey
>;

export function getApiV1ExamCorrectionGridQueryOptions(
  params?: GetApiV1ExamCorrectionGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamCorrectionGridQueryKey(params);
  return queryOptions<
    GetApiV1ExamCorrectionGridQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectionGrid400
      | GetApiV1ExamCorrectionGrid401
      | GetApiV1ExamCorrectionGrid500
    >,
    GetApiV1ExamCorrectionGridQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamCorrectionGrid(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a grade de correção de texto para uma publicação de exame específica com paginação. **(Requer Authorization para autenticação)**
 * @summary Carregar a grade de correção do exame (Requer Authorization para autenticação)
 * {@link /api/v1/exam/correction-grid}
 */
export function useGetApiV1ExamCorrectionGrid<
  TData = GetApiV1ExamCorrectionGridQueryResponse,
  TQueryData = GetApiV1ExamCorrectionGridQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamCorrectionGridQueryKey,
>(
  params?: GetApiV1ExamCorrectionGridQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamCorrectionGridQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamCorrectionGrid400
          | GetApiV1ExamCorrectionGrid401
          | GetApiV1ExamCorrectionGrid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamCorrectionGridQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ExamCorrectionGridQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectionGrid400
      | GetApiV1ExamCorrectionGrid401
      | GetApiV1ExamCorrectionGrid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
